import UndoSVG from "@design-system/ui-icons/vanilla/Undo"
import { createIcon } from "../createIcon"

export const UndoIcon = createIcon(UndoSVG)
